import { AqdbBatch } from '../../../../aqdb/models/aqdb-batch';
import { TranslationService } from '../../../services/translation.service';
import { MultiLineValueTypes } from '../../cell-renderers/multi-line-value-types';
import { CommonColDef, MultiLineColDef } from '../../column-defs';
import { ColumnType } from '../../column-type';

export class AqdbChemicalCharacteristicsColumnDefinition {
	readonly AQDB_CHEMICAL_CHARACTERISTICS_CONFIGURATION:
	Map<string, CommonColDef<AqdbBatch> | CommonColDef<AqdbBatch, string>>;

	constructor(private readonly translationService: TranslationService) {
		this.AQDB_CHEMICAL_CHARACTERISTICS_CONFIGURATION =
		new Map<string, CommonColDef<AqdbBatch> | CommonColDef<AqdbBatch, string>>(
			[
				[
					'chemicalCharacteristics',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.chemical.characteristics'),
						colId: 'chemicalCharacteristics',
						hide: true,
						sortable: false,
					})
				],
				[
					'contentAl',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.aluminium'),
						fields: ['segments.chemicalList.contentAl'],
						colId: 'contentAl',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentAl).join(';') : '';
						},
					})
				],
				[
					'contentC',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.carbon'),
						fields: ['segments.chemicalList.contentC'],
						colId: 'contentC',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentC).join(';') : '';
						},
					})
				],
				[
					'contentCr',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.chromium'),
						fields: ['segments.chemicalList.contentCr'],
						colId: 'contentCr',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentCr).join(';') : '';
						},
					})
				],
				[
					'contentMn',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.manganese'),
						fields: ['segments.chemicalList.contentMn'],
						colId: 'contentMn',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentMn).join(';') : '';
						},
					})
				],
				[
					'contentNb',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.niobium'),
						fields: ['segments.chemicalList.contentNb'],
						colId: 'contentNb',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentNb).join(';') : '';
						},
					})
				],
				[
					'contentP',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.phosphorus'),
						fields: ['segments.chemicalList.contentP'],
						colId: 'contentP',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentP).join(';') : '';
						},
					})
				],
				[
					'contentS',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.sulphur'),
						fields: ['segments.chemicalList.contentS'],
						colId: 'contentS',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentS).join(';') : '';
						},
					})
				],
				[
					'contentSi',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.silicium'),
						fields: ['segments.chemicalList.contentSi'],
						colId: 'contentSi',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentSi).join(';') : '';
						},
					})
				],
				[
					'contentTi',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.titanium'),
						fields: ['segments.chemicalList.contentTi'],
						colId: 'contentTi',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentTi).join(';') : '';
						},
					})
				],
				[
					'contentV',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.vanadium'),
						fields: ['segments.chemicalList.contentV'],
						colId: 'contentV',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.contentV).join(';') : '';
						},
					})
				],
				[
					'carbonEquivalentValue',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.carbon.equivalent'),
						fields: ['segments.chemicalList.carbonEquivalentValue'],
						colId: 'carbonEquivalentValue',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.NUMBER_COLUMN,
						valueType: MultiLineValueTypes.NUMBER,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.carbonEquivalentValue).join(';') : '';
						},
					})
				],
				[
					'carbonEquivalentFormula',
					new MultiLineColDef<AqdbBatch>({
						headerName: this.translationService.getTR('aqdb.carbon.eq.formula'),
						fields: ['segments.chemicalList.carbonEquivalentFormula'],
						colId: 'carbonEquivalentFormula',
						groupId: 'chemicalCharacteristics',
						columnType: ColumnType.TEXT_COLUMN,
						valueType: MultiLineValueTypes.TEXT,
						valueGetter: params => {
							const qualityBatch = params.data;
							return qualityBatch
								? qualityBatch.segments.flatMap(item => item.chemicalList)
									.map(chemical => chemical.carbonEquivalentFormula).join(';') : '';
						},
					})
				],
			]
		);
	}
}
